<template>
  <div>
    <el-dialog
      v-if="visible"
      ref="dialog"
      v-dialog-drag
      :title="title"
      :visible.sync="visible"
      :width="loadWidth"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form ref="inputForm" :model="inputForm" label-width="80px" label-position="top">
        <el-form-item label="内容：" prop="content">
          <el-input
            v-model="inputForm.content"
            type="textarea"
            :max-length="1000"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <div>
          <el-button @click="visible = false">取消</el-button>
          <el-button type="primary" @click="confirm">确定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    isMb: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      title: "填写内容",
      curI: null,
      inputForm: {
        content: "",
      },
    };
  },
  computed: {},
  methods: {
    loadWidth() {
      if (this.isMb) {
        return "80%";
      } else {
        return "10%";
      }
    },
    confirm() {
      this.$emit("confirm", this.inputForm);
      this.visible = false;
    },
    showDialog(data) {
      this.visible = true;
      this.inputForm.content = data;
    },
  },
};
</script>

<style scoped></style>
